<template>
  <div class="mitarbeiterFormular">
    <FormModule
      :formIdentifier="formIdentifier"
      :getFromTraegerschaftAfterCreation="false"
      @close="closeForm()"
      :editable="false"
      @saveSuccessful="zeigeSnackbarErfolg()"
      @afterApiLoadWithError="zeigeSnackbarFehler()"
    >
      <template v-slot:header>
        <h2>
          {{ uuid ? 'Mitarbeiter bearbeiten' : 'Neuen Mitarbeiter anlegen' }}
        </h2>
      </template>
      <template v-slot:content>
        <b-unit no-header>
          <v-row justify="center">
            <v-col cols="4">
              <b-select
                label="Projektträgerschaft"
                type="text"
                :rules="[validations.required]"
                :items="ex_pt"
                v-model="projekttraegerschaft"
              />
            </v-col>
            <v-col cols="4">
              <b-select
                label="Rolle"
                type="text"
                :rules="[validations.required]"
                :items="ex_role"
                v-model="rolle"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="4">
              <b-select
                label="Anrede"
                type="text"
                :items="ex_salutations"
                v-model="anrede"
              />
            </v-col>
            <v-col cols="4">
              <v-combobox
                  class="pt-1"
                  label="Titel"
                  type="text"
                  v-model="titel"
                  :items="ex_titles"
                  outlined
                  hideDetails="auto"
                  dense
                  @change="adaptTitle()"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="4">
              <b-text-field
                label="Nachname"
                type="text"
                :rules="[validations.required]"
                v-model="nachname"
              />
            </v-col>
            <v-col cols="4">
              <b-text-field
                label="Vorname"
                type="text"
                v-model="vorname"
                :rules="[validations.required]"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="4">
              <b-text-field
                label="Telefon"
                type="text"
                v-model="telefon"
                :rules="[validations.required]"
              />
            </v-col>
            <v-col cols="4">
              <b-text-field
                label="E-Mail Adresse"
                type="email"
                v-model="email"
                :rules="[validations.required, validations.emailValidation]"
              />
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="2">&nbsp;</v-col>
            <v-col v-if="uuid">
              <b-btn @click="zeigePasswortAendernPopup = true">Passwort ändern</b-btn>
            </v-col>
            <v-col v-else cols="4">
              <b-text-field
                  label="Passwort"
                  type="password"
                  v-model="passwort"
                  placeholder=" "
                  hint="Passwortrichtlinien: Das Passwort muss mindestens 8 Zeichen lang sein und mind. drei Zeichenarten (Kleinbuchstaben, Großbuchstaben, Zahlen, Sonderzeichen) enthalten."
                  :rules="[
                      validations.required,
                      validations.passwordValidation
                      ]"
              />
            </v-col>
          </v-row>
        </b-unit>
      </template>
    </FormModule>
    <PasswortAendernPopup
        v-if="zeigePasswortAendernPopup"
        :username="email"
        @close="zeigePasswortAendernPopup = false"
        @save="handlePasswordChange"
    />
    <v-snackbar v-model="showSnackbar" timeout="4000" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
import dataMixin from '@/mixins/data-mixin';
import FormModule from '@/components/base_components/FormModule';
import { mapMutations } from 'vuex';
import axios from 'axios';
import anreden from '@/utils/data/anreden';
import titel from '@/utils/data/titel';
import rollen from '@/utils/data/rollen';
import projekttraegerschaften from '@/utils/data/projekttraegerschaften';
import validations from '@/service/validations';
import PasswortAendernPopup from '@/components/popups/PasswortAendernPopup';

export default {
  name: 'MitarbeiterFormular',
  components: {
    FormModule,
    PasswortAendernPopup
  },
  props: {
    uuid: [String],
  },
  data() {
    return {
      formIdentifier: { type: 'mitarbeiter', uuid: this.uuid },
      //TODO Beispiele entfernen
      ex_titles: titel,
      ex_salutations: anreden,
      ex_role: rollen,
      ex_pt: projekttraegerschaften,
      validations: validations,
      showSnackbar: false,
      snackbarColor: '',
      snackbarText: '',
      zeigePasswortAendernPopup: false,
    };
  },
  mixins: [
    dataMixin('projekttraegerschaft', 'persistentData.projektTraegerschaft'),
    dataMixin('anrede', 'persistentData.anrede'),
    dataMixin('titel', 'persistentData.titel'),
    dataMixin('rolle', 'persistentData.rolle'),
    dataMixin('telefon', 'persistentData.telefon'),
    dataMixin('email', 'persistentData.email'),
    dataMixin('vorname', 'persistentData.vorname'),
    dataMixin('nachname', 'persistentData.nachname'),
    dataMixin('passwort', 'persistentData.passwort'),
  ],
  computed: {},
  created() {
    this.resetFormData();
  },
  methods: {
    ...mapMutations('formData', ['resetFormData']),
    updateUserData() {
      axios.put(this.formIdentifier.type, this.getFormData.persistentData);
    },
    closeForm() {
      this.$router.push('/mitarbeiter');
    },
    rolleVorbereiten() {
      return this.ex_role.find((item) => item.value == this.rolle);
    },
    mitarbeiterSpeichern() {
      return this.formIdentifier.uuid === undefined
        ? axios.post(`/v1/mitarbeiter`, this.getFormData.persistentData)
        : axios.put(
            `/v1/mitarbeiter/${this.formIdentifier.uuid}`,
            this.getFormData.persistentData
          );
    },
    zeigeSnackbarErfolg() {
      this.snackbarText = 'Speichern erfolgreich';
      this.snackbarColor = 'primary';
      this.showSnackbar = true;
    },
    zeigeSnackbarFehler() {
      this.snackbarText = 'Speichern fehlgeschlagen';
      this.snackbarColor = 'red';
      this.showSnackbar = true;
    },
    handlePasswordChange() {
      this.snackbarText = 'Passwort erfolgreich geändert';
      this.showSnackbar = true;
      this.snackbarColor = 'primary';
    },
    adaptTitle() {
      const title = this.titel;
      if (title.value) {
        this.titel = title.value;
      }
    }
  },
};
</script>

<style scoped>
</style>
